import Rails from '@rails/ujs';
import { ref } from 'vue';
import api from './index';

const DEFAULT_LIMIT = 5;

const token = ref(Rails.csrfToken());
let headers = {};
if (token.value) {
  headers = { 'X-CSRF-Token': token.value };
}

export default {
  unified(searchText: string, limit = DEFAULT_LIMIT) {
    return api({
      method: 'get',
      url: `/api/internal/search/unified?search_text=${encodeURIComponent(searchText)}&limit=${limit}`,
      headers,
    });
  },
}; 